// @flow
import { connect } from 'react-redux'
import type { Store } from '../redux/ducks'
import _ from 'lodash'
import ImagePreview from './ImagePreview'
import getDefaultCrop from './getDefaultCrop'
import { getMedia } from '../redux/selectors'
import type { Crop } from './types'

type OwnProps = {|
  storeId: string,
  width: number,
  crop?: ?Crop,
  ratio?: number
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const image = getMedia(state, ownProps.storeId)

  return {
    imageSrc: image.src,
    size: {
      width: image.width,
      height: image.height
    },
    crop: ownProps.crop || getDefaultCrop(image.width, image.height, ownProps.ratio || 1.0)
  }
}

const ImagePreviewContainer = connect<Object, OwnProps, _, _, _, _>(mapStateToProps)(ImagePreview)

export default ImagePreviewContainer
